import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksServices(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].getOrderGeneratorsFieldsWorksServices,
		{
			urlParams: {
				companyId,
        generatorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksService(companyId, generatorId, serviceId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].getOrderGeneratorsFieldsWorksService,
		{
			urlParams: {
				companyId,
        generatorId,
				serviceId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksService(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].createOrderGeneratorsFieldsWorksService,
		{
			urlParams: {
				companyId,
        generatorId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWorksService(companyId, generatorId, serviceId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].putOrderGeneratorsFieldsWorksService,
		{
			urlParams: {
				companyId,
        generatorId,
				serviceId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksService(companyId, generatorId, serviceId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].patchOrderGeneratorsFieldsWorksService,
		{
			urlParams: {
				companyId,
        generatorId,
				serviceId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksService(companyId, generatorId, serviceId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].deleteOrderGeneratorsFieldsWorksService,
		{
			urlParams: {
				companyId,
        generatorId,
				serviceId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksServices,
	getOrderGeneratorsFieldsWorksService,
	createOrderGeneratorsFieldsWorksService,
	putOrderGeneratorsFieldsWorksService,
	patchOrderGeneratorsFieldsWorksService,
	deleteOrderGeneratorsFieldsWorksService,
}

